<template>
  <div id="app" :class="{mobile}">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
let mobile = false
export default {
  data () {
    return {
    }
  },
  mounted () {
    const documentEl = document.documentElement
    this.updateMobileStatus(documentEl)
    window.onresize = () => {
      // import('@/utils/rem.js')
      this.updateMobileStatus(documentEl)
    }
  },
  methods: {
    updateMobileStatus (documentEl) {
      if (documentEl.clientWidth < 420) {
        mobile = true
        /* eslint-disable no-unused-expressions */
        import('@/utils/rem.js')
      } else {
        mobile = false
      }
      this.$store.dispatch('UPDATEDEVICESTATUS', mobile)
    }
  },
  computed: {
    ...mapGetters(['mobile'])
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 16px;
  background-color: #F5F5F5;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
